module.exports = __webpack_public_path__ + "img/gpi_logo.428987db.png";